
<template>
  <!--编辑门禁设备-->
  <div class="advanced-form">
    <a-form :form="form" layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex" justify="space-between">
            <a-col v-for="(item, index) of deviceInfoList" :key="index" v-bind="$store.state.advanced_colWidth">
              <a-form-item v-if="item.label === '设备名称'" :label="item.label">
                <a-input v-decorator="['deviceName', formOptions.deviceName]" placeholder="请输入设备名称"/>
              </a-form-item>

              <a-form-item v-else-if="item.label === '设备编码'" :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
                <a-button @click="openModal" type="link">替换</a-button>
              </a-form-item>

              <a-form-item v-else :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="card">
      <div class="card-head">
        <h3>运行参数</h3>
      </div>
      <div class="card-body">
        <a-row type="flex" :gutter="24">
          <a-col v-for="(item, index) of functionList" :key="index" v-bind="$store.state.advanced_colWidth">
            <a-form-item class="dev-param-select" v-if="item.inputType==='select'" :label="item.label" :extra="item.extra" has-feedback>
              <a-select
                v-decorator="item.props"
                allowClear
                showSearch
                :filterOption="filterOption"
                :placeholder="item.placeholder">
                <a-select-option v-for="(el, order) of item.options" :key="order" :value="el.value">
                  {{el.label}}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item v-if="item.inputType==='input'" :label="item.label" :extra="item.extra" has-feedback>
              <a-input style="width: 60%" v-decorator="item.props" :placeholder="item.placeholder"/>
            </a-form-item>

            <a-form-item v-if="item.inputType==='inputNumber'" :label="item.label" :extra="item.extra" has-feedback>
              <a-input-number v-decorator="item.props" :placeholder="item.placeholder" :min="item.min" :max="item.max"/>
            </a-form-item>

            <a-form-item v-if="item.inputType==='switch'" :label="item.label" :extra="item.extra">
              <a-switch v-decorator="item.props" checkedChildren="开" unCheckedChildren="关"/>
            </a-form-item>
          </a-col>
        </a-row>
      </div>
    </div>
    </a-form>

    <x-toolbar :toolBarList="toolBarList" :btnLoading="btnLoading"></x-toolbar>

    <!--修改设备编码的弹窗-->
    <a-modal
      deviceName="编辑设备编码"
      :visible="visible"
      @ok="changeSnCode"
      @cancel="visible=false"
      :confirmLoading="devCodeLoading.loading"
      okText="确认"
      cancelText="取消"
      :okButtonProps="{ props: { disabled: !haveChanged } }"
      destroyOnClose
      :width="800"
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="snCodeForm">
      <a-form-item label="设备编码" v-bind="$store.state.modal_ItemLayout">
        <a-input @input="snCodeChange" v-decorator="['deviceSncode', formOptions.deviceSncode]" placeholder="请输入设备编码"/>
      </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { inputSearch } from 'ant-design-vue-admin-x';
export default {
  mixins: [inputSearch],
  name: 'editSmartDoor',
  data () {
    return {
      haveChanged: false,
      visible: false,
      devCodeLoading: { loading: false },
      btnLoading: { loading: false },
      actionList: [],
      functionList: [],
      toolBarList: [
        {text: '取消', handle: (item) => this.$router.go(-1), key: 'cancel'},
        {text: '提交', handle: (item) => this.handleSubmit(), type: 'primary', loading: true, key: 'submit'}
      ],
      formOptions: {
        deviceName: {
          validateTrigger: 'blur',
          rules: [
            {required: true, message: '请输入设备名称'},
            {min: 2, max: 20, message: '设备名称为2-20个字'}
          ]
        },
        deviceSncode: {
          validateTrigger: 'blur',
          rules: [
            {required: true, message: '请输入设备编码'},
            {min: 2, max: 20, message: '设备编码为2-20个字'}
          ]
        }
      },
      deviceInfoList: [
        {key: 'communityName', label: '小区', value: ''},
        {key: 'positionName', label: '位置', value: ''},
        {key: 'deviceName', label: '设备名称', value: ''},
        {key: 'factoryName', label: '设备厂家', value: ''},
        {key: 'productType', label: '产品型号', value: ''},
        {key: 'deviceSncode', label: '设备编码', value: ''}
      ]
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this); // 实例对象下$form方法通过createForm方法创建表单，并赋值给this.form
    this.snCodeForm = this.$form.createForm(this);
  },
  mounted () {
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/device/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        this.actionList = data.actionList;
        for (let item in data) {
          this.loopSetVal(this.deviceInfoList, data, item);
        }

        let inputType = { enum: 'select', bool: 'switch', int: 'inputNumber', float: 'inputNumber', string: 'input' };
        let valueObj = {};
        let list = [];
        data.actionList.forEach((el, index) => {
          let label = el.settingName;
          let type = el.settingType;
          let propId = el.settingId;
          let obj = {
            label: label,
            inputType: inputType[type],
            options: [],
            placeholder: '',
            extra: '',
            props: [`${propId}`]
          };
          valueObj[`${propId}`] = el.settingVal;
          let valContent = JSON.parse(el.settingValContent);
          if (type === 'enum') {
            let option = [];
            valContent.forEach((part) => {
              Object.keys(part).forEach(item => {
                option.push({ label: part[item], value: item });
              });
            });
            obj.options = option;
            obj.placeholder = `请选择${label}`;
            obj.props[1] = {rules: [{required: true, message: `请选择${label}`}]};
          }

          if (type === 'int' || type === 'float') {
            let extra = this.generateExtra(valContent, el.settingUnique);
            obj.options = [];
            obj.placeholder = `${label}`;
            obj.min = parseFloat(valContent.min);
            obj.max = parseFloat(valContent.max);
            obj.extra = extra;
            let rule;
            if (type === 'int') {
              rule = {pattern: /^\d*$/, message: '请输入整数'};
            } else {
              rule = {pattern: /^\d+(\.\d{0,3})?$/, message: '请输入小数或整数，最多三位小数'};
            }
            obj.props[1] = {
              validateTrigger: 'change',
              rules: [
                {required: true, message: `请输入${label}`},
                rule
              ]
            };
          }

          if (type === 'bool') {
            let settingVal = el.settingVal;
            if (settingVal) {
              let arr = [];
              for (let item in valContent) {
                if (settingVal === valContent[item]) {
                  if (item === 'open') {
                    valueObj[`${propId}`] = true;
                  } else {
                    valueObj[`${propId}`] = false;
                  }
                }
                arr.push(valContent[item]);
              }
              if (arr.indexOf(settingVal) < 0) { // 设置的值不在范围内 =》为false
                valueObj[`${propId}`] = false;
              }
            } else { // 没置值默认 =》为false
              valueObj[`${propId}`] = false;
            }
            obj.options = [];
            obj.placeholder = '';
            obj.props[1] = {
              valuePropName: 'checked',
              rules: [{required: true, message: `请选择${label}`}]
            };
          }

          if (type === 'string') {
            let len = parseFloat(valContent);
            obj.options = [];
            obj.placeholder = `请输入${label}`;
            obj.extra = `值长度: 0-${len}`;
            obj.props[1] = {
              validateTrigger: 'change',
              rules: [
                {required: true, message: `请输入${label}`},
                { min: 0, max: len, message: `值长度为0-${len}` }
              ]
            };
          }
          list.push(obj);
        });
        valueObj = {...valueObj, deviceName: data.deviceName};
        this.functionList = list;
        this.$nextTick(() => {
          this.form.setFieldsValue(valueObj);
        });
      });
    },
    loopSetVal (target, data, item) {
      target.forEach((el) => {
        if (el.key === item) {
          el.value = data[item];
        }
      });
    },
    /* 打开 替换设备编码 弹窗 */
    openModal () {
      this.haveChanged = false;
      this.visible = true;
      this.deviceInfoList.forEach((el) => {
        if (el.key === 'deviceSncode') {
          let values = { [el.key]: el.value };
          this.$nextTick(() => {
            this.snCodeForm.setFieldsValue(values);
          });
        }
      });
    },
    /** 设备编码 input 事件 */
    snCodeChange (e) {
      let sncode = this.deviceInfoList.filter(item => item.key === 'deviceSncode');
      let devSncode = sncode && sncode.length && sncode[0].value;
      e.target.value !== devSncode ? this.haveChanged = true : this.haveChanged = false;
    },
    /* 替换设备编码 */
    changeSnCode () {
      this.snCodeForm.validateFields((err, values) => {
        if (err) { return; }
        let newValues = {...values};
        newValues.deviceId = this.$route.query.id;
        this.$post({
          url: '/device/changeDeviceCode',
          params: newValues,
          btnLoading: this.devCodeLoading
        }).then(({ data }) => {
          this.visible = false;
          this.$message.success('修改成功！');
          this.$store.commit('setOptData', true);
          this.$router.go(-1);
        });
      });
    },
    /* 提交表单 */
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        let arr = [];
        let newValues = {};
        for (let item in values) {
          if (item !== 'deviceName') {
            if (typeof values[item] === 'boolean') {
              this.actionList.forEach((el) => {
                if (el.settingId.toString() === item) {
                  let content = JSON.parse(el.settingValContent);
                  values[item] === true ? values[item] = content['open'] : values[item] = content['close'];
                }
              });
            }
            arr.push({ [item]: values[item] });
          } else {
            newValues[item] = values[item];
          }
        }
        arr = JSON.stringify(arr);
        newValues.actionParam = arr;
        newValues.deviceId = this.$route.query.id;
        this.formSubmit(newValues);
      });
    },
    /** 接口请求 */
    formSubmit (param) {
      this.$put({
        url: '/device',
        params: param,
        btnLoading: this.btnLoading
      }).then((res) => {
        this.$store.commit('setOptData', true);
        this.$message.success('修改成功！');
        this.$router.go(-1);
      });
    }
  }
};
</script>
